<template lang="pug">
v-card(flat)
  v-dialog(
    v-model='isModalCancelarCita'
    width="400",
    @click:outside="closeModalAnular()"
    transition='dialog-bottom-transition'
  )
    v-card.pa-2
      h1.text-center.font-weight-700.font-size-20.py-4 ¿Estas seguro que deseas cancelar la cita?
      .pa-4
        v-textarea(
          hide-details,
          autofocus
          ref="comentarioParaCancelar"
          v-model='comentarioParaCancelar'
          placeholder='Describe un motivo por el cual deseas cancelar la cita'
          color="primary"
          solo
          dense,
          rows="8"
        )
      v-card-actions
        v-spacer
        v-btn(color='primary'  v-if="!isMovil" text='' small @click="closeModalCancelarCita()")
          | Cancelar
        v-btn(color='primary' :block="isMovil" :small="!isMovil" @click="fetchEliminarCita()")
          | Cancelar cita
  v-toolbar(color='primary' dark='')
    v-btn(icon='', @click="close()" v-if="isMovil")
      v-icon arrow_back
    v-toolbar-title.font-size-15
      .d-flex.jc-center.fd-column(v-if="!id")
        span.font-weight-700 Nueva programación {{fechaPicker}}
        span.font-size-11 Programa ahora y luego podras visualizarlo en el modulo principal
      .d-flex.jc-center.fd-column(v-else)
        span.font-weight-700 Editando programacion  de cita{{`#${id}`}}
        span.font-size-11 Verifica bien los cambios antes de reprogramar
    v-spacer
    v-menu(transition='slide-x-transition' bottom='' right='')
      template(v-slot:activator='{ on, attrs }')
        v-btn.animated.fadeInUp.faster(icon dark  v-bind='attrs' v-on='on' v-if="id")
          v-icon  more_vert
      v-list(dense)
        v-list-item( @click="openModalCancelarCita()", :disabled="cita.ingresadoAtaller === 1")
          v-list-item-title
            | Eliminar esta programación
        v-list-item( @click="goTo(`/programacion/citas/${cita.id}`)", v-if="noEstaEnAgenda")
          v-list-item-title
            | Visualizar cita en agenda
  .pa-4(v-if="!isLoading")
    .d-flex(v-if="cita.ingresadoAtaller")
      v-alert.flex-1.mb-2( border='left' color='success' dark='' outlined icon="check_circle" dense)
        small.font-size-11 Esta cita ya fue cerrada por que el equipo ya ingreso a taller
    v-btn.mb-3( color="secondary primary--text" small block, v-if="cita.numeroTicket && !noEstaEnAgenda"  @click="goTo('/ticket/' + cita.numeroTicket)")
      v-icon.mr-2 visibility
      | ver detalles de ticket
    v-card.elevation-1.mb-4(v-if="cita.numeroTicket" key="ticketSeleccionada")
      v-list(dense)
        v-list-item
          v-chip.mr-2(:color="cita.ingresadoAtaller ? 'success' : 'orange'" label  small text-color='white')
            span.font-weight-700.font-size-11(v-html='cita.numeroTicket')
          v-list-item-content
            v-list-item-title
              span.font-weight-700.font-size-14 {{cita.titulo}}
            v-list-item-subtitle.grey--text.font-size-11(v-if="cita.fechaRegistro") fué creado hace {{cita.fechaRegistro | now}}
            v-list-item-subtitle.grey--text.font-size-11(v-else) En proceso de creación
          v-list-item-action(v-if="!noEstaEnAgenda && !cita.ingresadoAtaller")
            //- v-btn(color="info", fab x-small)
            v-btn(color="primary",  small, @click="clearTicketSeleccionado")
              v-icon keyboard_arrow_left
              //- v-icon link
              span Cambiar
    listado-tickets-seleccionar.mb-6( :toCita="true", v-if="!cita.numeroTicket" :numero="cita.numeroTicket" @selected="obtenerTicketSeleccionado")
    .d-flex.mb-3(v-if="fechaPicker")
      small.primary--text.font-size-11 *Los puntos de color en el calendario hacen referencia a las fechas festivas.*
    v-date-picker(
      :events="arrayEvents"
      v-model='fechaPicker'
      v-if="fechaPicker"
      full-width
      :landscape='false'
      no-title
      color="primary"
      :disabled="cita.ingresadoAtaller === 1"
      event-color="primary",
      @change="verificarFechaYObtenerHoras()"
    )
    v-select(v-model='cita.horaCita' :disabled="!horas.length || cita.ingresadoAtaller === 1"  item-text="hora" :items='horas'  label='Horas disponibles para la fecha seleccionada' v-if="fechaPicker" dense hide-details )
    .d-flex.mt-2
      v-btn(:block="isMovil" :small="!isMovil" block color="success" @click="fetchGuardarCita()" v-if="!cita.ingresadoAtaller" :disabled="!cita.numeroTicket || !fechaPicker || !cita.horaCita")
        span(v-if="id") reprogramar cita
        span(v-else) generar cita
  div(v-else)
    .pa-4
      v-skeleton-loader( type='list-item-avatar-three-line')
      v-skeleton-loader( type='card-heading')
      v-skeleton-loader( type='card-heading')
</template>
<script>
import moment from 'moment'
import { apiDelete, apiGet, apiPost, notify } from '../util/general'
import lookupTickets from './c_listado_tickets_seleccionar'
export default {
  components : {
    'listado-tickets-seleccionar' : lookupTickets
  },
  props : {
    id : {
      type   : Number,
      default: 0
    },
    numeroTicket : {
      type   : Number,
      default: 0
    },
    isCreacionExterno : {
      type   : Boolean,
      default: false
    },
    noEstaEnAgenda : {
      type   : Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading             : false,
      fechaPicker           : '',
      cita                  : {},
      intervalo             : 15,
      horas                 : [],
      perfilUsuario         : localStorage.getItem('perfil'),
      isModalCancelarCita   : false,
      comentarioParaCancelar: '',
      arrayEvents           : []
    }
  },
  created () {
    var vm = this
    if (vm.isCreacionExterno) {
      if (!vm.numeroTicket) notify(vm, 'error', 'Error', 'El numero de ticket enviado no es valido')
      else vm.fetchTicket()
    } else {
      if (vm.id) vm.fetchCita()
      else {
        vm.cita.ingresadoAtaller = 0
      }
    }
    vm.fetchDiasFestivos()
  },
  filters : {
    now: function (value) {
      if (!value) return ''
      return moment(value).fromNow()
    }
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  },
  methods : {
    fetchDiasFestivos () {
      var vm = this
      var obj = {
        formatoDate: 'YYYY-MM-DD'
      }
      // vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obtener información de la cita' })
      apiGet(vm, '/dias_festivo/obtener', obj, function (data) {
        vm.arrayEvents = data.lista
        console.log('dias deeeee', vm.arrayEvents)
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        // vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    openModalCancelarCita () {
      var vm = this
      vm.isModalCancelarCita = true
      vm.comentarioParaCancelar = ''
    },
    closeModalCancelarCita () {
      var vm = this
      vm.isModalCancelarCita = false
      vm.comentarioParaCancelar = ''
    },
    verificarFechaYObtenerHoras () {
      var vm = this
      var fecha = moment(vm.cita.fechaDesde)
      vm.horas = []
      if (fecha.isValid()) {
        vm.fetchHorasDisponibles()
      }
    },
    goTo (page) {
      var vm = this
      if (vm.perfilUsuario === 'usuario-contrato' || vm.perfilUsuario === 'usuario') {
        window.open(page, '_blank')
        // Router.push(page)
      } else {
        window.open(page, '_blank')
        // RouterDispatcher.push(page)
      }
    },
    close () {
      var vm = this
      vm.$emit('close')
    },
    clearTicketSeleccionado () {
      var vm = this
      vm.cita.numeroTicket = 0
      vm.fechaPicker = ''
    },
    obtenerTicketSeleccionado (ticket) {
      var vm = this
      vm.$set(vm.cita, 'numeroTicket', ticket.numero)
      vm.$set(vm.cita, 'titulo', ticket.titulo)
      vm.fechaPicker = moment().format('YYYY-MM-DD')
      // vm.cita.numeroTicket = ticket.numero
      // vm.cita.titulo       = ticket.titulo
    },
    updatedList () {
      var vm = this
      vm.$emit('update')
    },
    fetchHorasDisponibles () {
      var vm = this
      if (!vm.fechaPicker) {
        notify(vm, 'error', 'Error', 'La fecha de programación no es valida')
        vm.horas = []
        return
      }
      var obj = {
        fecha: vm.fechaPicker
      }
      // vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obtener información de la cita' })
      apiGet(vm, '/cita/verificar/horas', obj, function (data) {
        vm.horas = data.horasDisponibles
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        // vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchEliminarCita () {
      var vm = this
      if (!vm.comentarioParaCancelar) {
        notify(vm, 'error', 'Error', 'Ingrese un motivo por el cual deseas cancelar la cita ')
        vm.$refs.comentarioParaCancelar.focus()
        return
      }

      var obj = {
        codigo: vm.id,
        motivo: vm.comentarioParaCancelar
      }
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Eliminando programación' })
      apiDelete(vm, '/cita/eliminar', obj, function (data) {
        notify(vm, 'success', 'Exito', 'La cita se eliminó correctamente')
        vm.updatedList()
        vm.close()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchCita () {
      var vm = this
      var obj = {
        codigo: vm.id
      }
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obtener información de la cita' })
      apiGet(vm, '/cita/obtener', obj, function (data) {
        vm.cita = data.lista[0]
        vm.fechaPicker = moment(vm.cita.fechaDesde).format('YYYY-MM-DD')
        vm.$set(vm.cita, 'horaCita',  moment(vm.cita.fechaDesde).format('HH:mm'))
        if (vm.fechaPicker) vm.fetchHorasDisponibles()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        vm.close()
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchGuardarCita () {
      var vm         = this
      var obj        = {
        id              : vm.id,
        titulo          : vm.cita.titulo,
        fecha           : vm.fechaPicker,
        hora            : vm.cita.horaCita,
        ingresadoAtaller: vm.cita.ingresadoAtaller,
        numeroTicket    : vm.cita.numeroTicket
      }
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Guardando datros de cita' })
      apiPost(vm, '/cita/guardar', obj, function (data) {
        notify(vm, 'success', 'Exito', 'Los datos de la cita se guardaron correctamente')
        vm.updatedList()
        vm.close()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, () => {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchTicket () {
      var vm = this
      vm.isLoading = true
      var url = 'ticket/obtener'
      var obj = {
        numero: vm.numeroTicket
      }
      apiGet(vm, url, obj, function (data) {
        var info                   = data.lista[0]
        var titulo                 = `${info.razonSocial}`
        if  (info.serie)  titulo  += ` - ${info.serie}`
        if  (info.modelo)  titulo += ` - ${info.modelo}`
        vm.$set(vm.cita, 'titulo', titulo)
        vm.$set(vm.cita, 'numeroTicket',  info.numero)
        // vm.cita.titulo         = titulo
        // vm.cita.numeroTicket   = info.numero
        vm.fechaPicker = moment().format('YYYY-MM-DD')
        if (vm.fechaPicker) vm.fetchHorasDisponibles()
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// c_card_form_programacion_cita.vue?5178fa2b